(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  var _cookiePolicy = Cookies.get("cookiePolicy");

  if ($(".cookie-policy").length > 0 && _cookiePolicy != "true") {
    $('.cookie-policy').addClass('active');
  }

  $('.cookie-policy .cookie-close').click(function (e) {
    e.preventDefault();
    $(this).parents('.cookie-policy').removeClass('active');
    Cookies.set("cookiePolicy", "true", {
      expires: 999
    });
  });
  var year = new Date().getFullYear();
  $('#year').html(year);
}

},{}],2:[function(require,module,exports){
"use strict";

var _cookie = _interopRequireDefault(require("./app/cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

$(document).ready(function () {
  (0, _cookie["default"])();
  $('.main-speed-menu .owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    dots: true,
    transitionStyle: "fade",
    smartSpeed: 700,
    margin: 1,
    loop: true,
    //mouseDrag:false,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
        //margin:20,
        stagePadding: 40
      },
      576: {
        stagePadding: 40,
        items: 2,
        slideBy: 2
      },
      768: {
        items: 2,
        slideBy: 2,
        stagePadding: 40
      }
    }
  });
  $('.main-products .owl-carousel').owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    transitionStyle: "fade",
    smartSpeed: 700,
    margin: 30,
    loop: true,
    //mouseDrag:false,
    responsive: {
      0: {
        items: 1,
        slideBy: 1
      },
      576: {
        items: 2,
        slideBy: 2
      },
      991: {
        items: 3,
        slideBy: 3
      }
    }
  });
});

},{"./app/cookie":1}]},{},[2]);
